import React, {FC} from 'react'
import {useIntl} from "react-intl";
import { PageTitle } from '../../../../_metronic/layout/core';
import ReceiptVoucher from './ReceiptVoucher';

const ReceiptVoucherWrapper: FC = () => {

  const intl = useIntl();
  const breadcrumbs = [
    {
      title: intl.formatMessage({id: 'MENU.DASHBOARD'}),
      path: '/dashboard',
      isActive: true,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    }
  ]

  return (
    <>
      <PageTitle breadcrumbs={breadcrumbs}>{intl.formatMessage({id: 'MENU.RECEIPT_VOUCHER'})}</PageTitle>
      <ReceiptVoucher />
    </>
  )
}

export default ReceiptVoucherWrapper
